/* eslint-disable complexity */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { createHash } from 'crypto';

import { useEffect, useState } from 'react';
import * as EmailValidator from "email-validator";
import { zodResolver } from '@hookform/resolvers/zod';
import He from 'he';
import Cookies from 'js-cookie';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { useForm } from 'react-hook-form';
import { v4 } from 'uuid';

import { TUCKERTUB_AUTH_TOKEN } from '~/constants';
import { useAuth, useGlobalState } from '~/context';
import { useRegisterUserMutation } from '~/graphql/__generated__';
import { ButtonWithArrow, Title } from '~/ui';
import type { RegisterSchemaInput } from '~/validation';
import { registerSchema } from '~/validation';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'


export const Register = () => {
  const { openFullScreenModal,closeFullScreenModal } =  useGlobalState()
  const [authErrorMessage, setAuthErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [signup, { loading: loadingSignup }] = useRegisterUserMutation();
  const [isPasswordShow, setPasswordShow ] = useState(false)
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [result, setResult] = useState(null);
  const [validationResult, setValidationResult] = useState<any>(null);
  const [emailBlurred, setEmailBlurred] = useState(false);


  const { login } = useAuth();
  const router = useRouter();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, touchedFields, dirtyFields },
    reset,
    setValue,
  } = useForm<RegisterSchemaInput>({
    resolver: zodResolver(registerSchema),
    mode: 'all'
  });
  const containsErrorsFirstName = Object.keys(errors).includes('firstName');
  const containsErrorsLastName = Object.keys(errors).includes('lastName');
  const containsErrorsEmail = Object.keys(errors).includes('email');
  const containsErrorsPassword = Object.keys(errors).includes('password');
  const firstNameValidation =
    !containsErrorsFirstName && dirtyFields.firstName
      ? 'primary-input-isValid'
      : touchedFields.firstName && 'primary-input-isInvalid';
  const lastNameValidation =
    !containsErrorsLastName && dirtyFields.lastName
      ? 'primary-input-isValid'
      : touchedFields.lastName && 'primary-input-isInvalid';
  const emailValidation =
    !containsErrorsEmail && dirtyFields.email
      ? 'primary-input-isValid'
      : touchedFields.email && 'primary-input-isInvalid';
  const passwordValidation =
    !containsErrorsPassword && dirtyFields.password
      ? 'primary-input-isValid'
      : touchedFields.password && 'primary-input-isInvalid';
      useEffect(() => {
        if (
          validationResult?.message === "Domain does not exist." ||
          validationResult?.message === "Internal server error."
        ) {
          //alert(JSON.stringify(validationResult))
          setIsValidEmail(false);
        }
        //alert(validationResult?.message)
      }, [validationResult]);
  async function onSubmitForm(values: RegisterSchemaInput) {
    openFullScreenModal()
    try {
      if (authErrorMessage) {
        setAuthErrorMessage('');
      }

      //console.log('REGISTEREDVALUES', values);
      const { data, errors } = await signup({
        variables: {
          input: {
            email: values.email,
            username: values.email.replace(/[^a-zA-Z0-9 ]/g, ''),
            firstName: values.firstName,
            lastName: values.lastName,
            password: values.password
          }
        }
      });

      const eventId = v4();
      fetch('/api/meta/complete-registration', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          eventId,
          eventSourceUrl: typeof window !== 'undefined' ? window.location.href : router.asPath,
          em: createHash('sha256').update(values.email ?? '-').digest('hex'),
          fn: createHash('sha256').update(values.firstName || '-').digest('hex'),
          ln: createHash('sha256').update(values.lastName || '-').digest('hex'),
        }),
      });

      // Server-side TikTok Events API — same event_id; sends RAW PII, hashed server-side
      fetch('/api/tiktok/complete-registration', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          eventId,
          eventSourceUrl: typeof window !== 'undefined' ? window.location.href : router.asPath,
          email: values.email,
        }),
      }).catch(() => {});

      // if (errors) {
      //   throw new Error(errors[0].message)
      // }

      reset();
      // Cookies.set(TUCKERTUB_AUTH_TOKEN, data?.registerUser?.user?.jwtAuthToken || 'no-token');
      setSuccessMessage('Successfully registered!, The email verification link sent to your email address please verify.');
      closeFullScreenModal()
      // router.replace(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/account/dashboard`);
      // const transformedValues = {
      //   firstName: values.firstName,
      //   lastName: values.lastName,
      //   email: values.email,
      //   password: values.password
      // }

      // const responseOptions = {
      //   method: 'POST',
      //   body: JSON.stringify(transformedValues),
      //   headers: {
      //     'Content-Type': 'application/json'
      //   }
      // }
      // const response = await fetch(
      //   `${process.env.NEXT_PUBLIC_FRONTEND_URL}/api/auth/register`,
      //   responseOptions
      // )
      // const data = await response.json()

      // console.log('REGISTERDATA', data)

      // if (data.success) {
      //   // toast.success('Registered!')
      //   login(data)
      //   reset()
      //   setSuccessMessage('Successfully registered!')
      //   router.replace(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/account/dashboard`)
      // } else {
      //   throw new Error(data.data.errorCode)
      // }
    } catch (error: any) {
      closeFullScreenModal()
      if (
        error?.message.includes(
          'this username is invalid because it uses illegal characters. Please enter a valid username'
        )
      ) {
        return setAuthErrorMessage(
          'this username is invalid because it uses illegal characters Please enter a valid username'
        );
      }
      if (error?.message) {
        return setAuthErrorMessage(error?.message);
      }

      setAuthErrorMessage('Something went wrong, please try agan');
    }
    closeFullScreenModal()
  }
  const verifyTLD = async (email1:any) => {
    try {
      const domain1 = email1.split("@")[1];
      if (!domain1) return;
      // Use the full domain (e.g. "tuckertub.com.au") for the DNS lookup,
      // not just the part after the first dot ("com.au"), which fails for
      // country-code TLDs like .com.au, .com.nz, etc.
      const response = await fetch(`/api/mandrill/verify-email?tld=${domain1}`);
      const data = await response.json();
      setResult(data.exists);
    } catch (error) {
      // console.error("Failed to verify TLD:", error);
    }
  };

  const handleValidateEmail = async (domain:any) => {
    try {
      const domain1 = domain.split("@")[1];
      const response = await fetch("/api/mandrill/verify-email-deep", {
        //const response = await fetch("/api/mandrill/verify-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ domain: domain1 }),
      });

      if (response.ok) {
        const data = await response.json();
        setValidationResult(data);
      } else {
        setValidationResult(null);
      }
    } catch (error) {
      // console.error("Error:", error);
      setValidationResult(null);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fieldName = e.target.name;
    const fieldValue = e.target.value;

    setIsValidEmail(EmailValidator.validate(fieldValue));
    setValue(fieldName as any, fieldValue as any);
  };
  // Run DNS checks ONLY on blur to prevent race conditions mid-typing
  // e.g. "tuckertub.com.a" slow DNS response overwriting "tuckertub.com.au" correct result
  const handleInputBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setEmailBlurred(true);
    handleValidateEmail(e.target.value);
    verifyTLD(e.target.value);
  };

  return (
    <section className="max-w-[440px]">
      <Title className="text-colorFourteen">Register</Title>
      <p className="py-8 text-base text-colorFourteen">
        Complete your details below to create a Tucker Tub account
      </p>
      <form onSubmit={handleSubmit(onSubmitForm)}>
        <div className="grid grid-cols-1 gap-3">
          <div>
            <input
              type="text"
              // style={{
              //   boxShadow: 'none',
              //   borderColor: 'transparent'
              // }}
              className={`primary-input input-border ${firstNameValidation}`}
              placeholder="First name"
              autoComplete="given-name"
              aria-label="First name"
              {...register('firstName')}
             
            />
            <p className="p-0 text-colorThirteen">
              {containsErrorsFirstName && errors.firstName?.message}
            </p>
          </div>
          <div>
            <input
              type="text"
              // style={{
              //   boxShadow: 'none',
              //   borderColor: 'transparent'
              // }}
              className={`primary-input input-border ${lastNameValidation}`}
              placeholder="Last name"
              autoComplete="family-name"
              aria-label="Last name"
              {...register('lastName')}
            />
            <p className="p-0 text-colorThirteen">
              {containsErrorsLastName && errors.lastName?.message}
            </p>
          </div>
          <div>
            <input
               type="email"
               name="email"
               // style={{
               //   boxShadow: "none",
               //   borderColor: "transparent",
               // }}
               className={`primary-input input-border ${emailValidation}`}
               placeholder="Email address"
               autoComplete="email"
               aria-label="Email address"
               //{...register("email")}
               onChange={handleInputChange}
               onBlur={handleInputBlur}
            />
            {/* <p className="p-0 text-colorThirteen">{containsErrorsEmail && errors.email?.message}</p> */}
            {(validationResult?.valid && isValidEmail) ||
            (result && isValidEmail) ? (
              <p className="p-0 text-colorThirteen">{containsErrorsEmail && errors.email?.message}</p>
            ) : (
              emailBlurred===true && <p className="p-0 text-colorThirteen">
                Please enter a valid email address.
              </p>
            )}
          </div>
          <div>
            <div 
            className='register-box-alignment'
            // style={{ display:'flex',alignItems:'flex-end',flexDirection:'column' }} 
            >
            <input
              type={ isPasswordShow ? 'text' :'password' }
              // style={{
              //   boxShadow: 'none',
              //   borderColor: 'transparent'
              // }}
              className={`primary-input input-border ${passwordValidation}`}
              placeholder="Password"
              autoComplete="current-password"
              aria-label="Password"
              {...register('password')}
            />
                <span onClick={()=>  setPasswordShow((e)=> !e ) } 
                className='register-showpass-alignment'
                // style={{ position:'relative', right:10, top:-30, cursor:'pointer' }} 
                > { isPasswordShow ?  <AiOutlineEye  /> : <AiOutlineEyeInvisible />  }  </span>
            </div>
            <p 
            // style={{ marginTop: -20 }} 
            className="p-0 text-colorThirteen signin-pass-err">
              {containsErrorsPassword && errors.password?.message}
            </p>
          </div>
          <div className="my-5 space-y-3">
            <div className="flex items-center gap-x-2">
              <input
                type="checkbox"
                className="h-5 w-5 rounded-full border-colorFourteen text-colorTen focus:ring-transparent"
                id="mailing-list"
              />
              <label htmlFor="mailing-list" className="text-base">
                Sign up for the Tucker Tub mailing list
              </label>
              <p className="p-0 text-colorThirteen">{errors.isSignUpEmail?.message}</p>
            </div>
            <div className="flex items-center gap-x-2">
              <input
                type="checkbox"
                className="h-5 w-5 rounded-full border-colorFourteen text-colorTen focus:ring-transparent"
                id="terms"
                {...register('isAgreedToTerms')}
              />
              <label htmlFor="terms" className="text-base">
                I agree to the{' '}
                <NextLink target="_blank" href="/policies/terms-and-conditions" className="underline">
                  Terms of Service
                </NextLink>
              </label>
            </div>
            <p className="p-0 text-colorThirteen">{errors.isAgreedToTerms?.message}</p>
          </div>
          <div>
            <ButtonWithArrow buttonType="submit" buttonVariant="primary"     disabled={
                isSubmitting ||
               
                !result ||
                result === null ||
                !isValidEmail
              }>
              {isSubmitting || loadingSignup ? 'Registering...' : 'Register'}
            </ButtonWithArrow>
          </div>
          {authErrorMessage && (
            <div>
              <p
                className="p-0 text-colorThirteen"
                dangerouslySetInnerHTML={{ __html: He.decode(authErrorMessage) }}
              />
            </div>
          )}
          {successMessage && !authErrorMessage && (
            <div>
              <p className="p-0 text-colorTen">{successMessage}</p>
            </div>
          )}
        </div>
      </form>
    </section>
  );
};
